const Big = require('big.js');

module.exports = {
	total: {
		dependentFields: ['amount'],
		formulate: ({ valueAddedTax, withholdingTax, amount }) => {
			const amountValue = Big(amount > 0 ? amount : 0);
			const valueAddedTaxAmount = amountValue
				.mul(valueAddedTax > 0 ? valueAddedTax : 0)
				.div(100);
			const withholdingTaxAmount = amountValue
				.mul(withholdingTax > 0 ? withholdingTax : 0)
				.div(100);
			return Number(
				amountValue
					.plus(valueAddedTaxAmount)
					.minus(withholdingTaxAmount)
					.toFixed(2)
			);
		}
	}
};
